import {Component, OnInit} from "@angular/core";
import {environment} from "../../../../environments/environment";
import {ApplicationStage} from "@app/app-config.model";

@Component({
  selector: "app-application-environment-message",
  templateUrl: "./application-environment-message.component.html",
  styleUrls: ["./application-environment-message.component.scss"],
})
export class ApplicationEnvironmentMessageComponent implements OnInit {
  message: string = null;
  private _stage: ApplicationStage = null;

  ngOnInit(): void {
    this._stage = environment.applicationStage as ApplicationStage;
    this.onApplicationEnvironmentChange(this._stage);
  }

  private onApplicationEnvironmentChange(appEnvironment: ApplicationStage): void {
    switch (appEnvironment) {
      case ApplicationStage.LOCAL:
        this.message = "Local server";
        break;

      case ApplicationStage.DEVELOPMENT:
        this.message = "DEV server";
        break;

      default:
        this.message = null;
    }
  }
}
